export default __webpack_public_path__ + "static/media/parent-kid-car.2e092676.svg";